import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ChatMessageProviderBase } from '../ChatMessageProviderBase/ChatMessageProviderBase';
export const ProviderAttachmentVerified = ({ message, containerClass }) => {
    const { t } = useTranslation();
    const newMessage = Object.assign(Object.assign({}, message), { content: t('label.uploaded_lab_results_verified') });
    const attachment = message.attachments[0];
    if (!attachment.verified) {
        return null;
    }
    return (_jsx(ChatMessageProviderBase, { message: newMessage, hiddenText: t('label.system_message_visble_for_patient'), isOutcome: true, containerClass: containerClass }));
};
